import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Separator from 'flarum/common/components/Separator';
export default function () {
  extend('ext:fof/user-directory/forum/components/UserDirectoryPage', 'oninit', function () {
    const q = m.route.param('q') || '';
    if (q.includes('is:followeduser')) {
      if (!this.enabledSpecialGroupFilters) this.enabledSpecialGroupFilters = {};
      this.enabledSpecialGroupFilters['ianm-follow-users'] = 'is:followeduser';
    }
  });
  extend('ext:fof/user-directory/forum/components/UserDirectoryPage', 'groupItems', function (items) {
    var _this$enabledSpecialG;
    // Get CheckableButton from Flarum's registry (it's in the same lazy-loaded chunk)
    const CheckableButton = flarum.reg.get('fof-user-directory', 'forum/components/CheckableButton');
    items.add('follow-users', m(CheckableButton, {
      className: "GroupFilterButton",
      icon: "fas fa-user-friends",
      checked: ((_this$enabledSpecialG = this.enabledSpecialGroupFilters) == null ? void 0 : _this$enabledSpecialG['ianm-follow-users']) === 'is:followeduser',
      onclick: () => {
        const id = 'ianm-follow-users';
        if (!this.enabledSpecialGroupFilters) this.enabledSpecialGroupFilters = {};
        if (this.enabledSpecialGroupFilters[id] === 'is:followeduser') {
          this.enabledSpecialGroupFilters[id] = '';
        } else {
          this.enabledSpecialGroupFilters[id] = 'is:followeduser';
        }
        this.changeParams(this.params().sort);
      }
    }, app.translator.trans('ianm-follow-users.forum.filter.following')), 65);
    items.add('separator', m(Separator, null), 50);
  });
}